import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="border-b border-line bg-ink py-16 md:py-24" aria-labelledby="bonuses-title" data-id="element-15" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-16" data-mp="avcvugoqpc6u">
        <div className="max-w-3xl" data-id="element-17" data-mp="autfh4eqmvux">
          <h2 id="bonuses-title" className="font-display text-4xl font-extrabold uppercase text-white md:text-6xl" data-id="element-18" data-mp="ftwlar2jl63y">
            🎁 You Also Get 6 Strategic Bonuses
          </h2>
          <p className="mt-4 text-base text-slate-300 md:text-lg" data-id="element-19" data-mp="5wi60uscund8">
            Included at no extra cost — ready to use from Day 1.
          </p>
          <p className="mt-6 inline-block rounded-md border border-gold/50 bg-gold/10 px-4 py-2 font-display text-lg font-bold uppercase tracking-wide text-gold md:text-xl" data-id="element-20" data-mp="3o3g1488g9hol">
            Real combined value: $328 — today included FREE
          </p>
          <p className="mt-3 text-sm font-semibold uppercase tracking-[0.12em] text-accent" data-id="element-21" data-mp="1r9uztaghokck">
            ⏳ All 6 bonuses are free only for today — they are removed when the launch price ends.
          </p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="3dead5fwyu6f2">
          {bonuses.map(bonus => <li key={bonus.id} className="flex h-full flex-col overflow-hidden rounded-xl border border-line bg-ink-800" data-id="element-23" data-mp="3r5gjnvynx4bg">
              <img src={bonus.image} alt={`${bonus.title} — bonus e-book cover`} className="h-56 w-full object-cover object-center" width={600} height={800} loading="lazy" data-id="element-24" data-mp="2zfar8g0u85ml" />
              <div className="flex flex-1 flex-col p-5" data-id="element-25" data-mp="33h5p1ajk80vm">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-gold" data-id="element-26" data-mp="33fm7lgm63js9">
                  {bonus.id} — {bonus.value} → FREE
                </p>
                <h3 className="mt-2 font-display text-xl font-bold uppercase leading-tight text-white" data-id="element-27" data-mp="irgbd0ulel4i">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300" data-id="element-28" data-mp="3cl0tx4b6gchu">{bonus.description}</p>
                <p className="mt-auto pt-4 text-xs font-bold uppercase tracking-[0.14em] text-emerald-400" data-id="element-29" data-mp="3hk3zcpv2kkqc">
                  Free today
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}